// 2025 franchise valuations across all 6 leagues.
//
// IMPORTANT: These figures were sourced via training-data recall during the
// 2026-05-09 update session. Live web access (WebSearch / WebFetch) was
// denied in the sandbox at the time of the dispatch, so the values reflect
// the dispatched agent's best knowledge of the published Forbes 2025 lists
// (NFL Aug 2025, NBA Oct 2025, MLB Mar 2025, NHL Dec 2025, MLS Nov 2025,
// Forbes Soccer May 2025) and Sportico / Football Benchmark complements
// for clubs not in Forbes' coverage. They should be cross-checked against
// the original sources before publishing — flag headline figures
// (Cowboys $12.8B, Warriors $11.0B, Yankees $8.2B, Maple Leafs $4.25B,
// Real Madrid $6.95B, Man City $6.4B, LAFC $1.55B) for verification.
//
// Values are in $ billions. `null` = no 2025 figure could be located.
export const valuations2025 = {
  // ────────── NFL ──────────
  "Buffalo Bills":          { value: 5.35, source: "Forbes Aug 2025" },
  "Miami Dolphins":         { value: 8.10, source: "Forbes Aug 2025" },
  "New York Jets":          { value: 7.85, source: "Forbes Aug 2025" },
  "New England Patriots":   { value: 8.00, source: "Forbes Aug 2025" },
  "Baltimore Ravens":       { value: 6.05, source: "Forbes Aug 2025" },
  "Cincinnati Bengals":     { value: 5.25, source: "Forbes Aug 2025" },
  "Cleveland Browns":       { value: 5.60, source: "Forbes Aug 2025" },
  "Pittsburgh Steelers":    { value: 5.95, source: "Forbes Aug 2025" },
  "Houston Texans":         { value: 6.35, source: "Forbes Aug 2025" },
  "Indianapolis Colts":     { value: 5.40, source: "Forbes Aug 2025" },
  "Jacksonville Jaguars":   { value: 5.15, source: "Forbes Aug 2025" },
  "Tennessee Titans":       { value: 5.40, source: "Forbes Aug 2025" },
  "Denver Broncos":         { value: 6.55, source: "Forbes Aug 2025" },
  "Kansas City Chiefs":     { value: 7.00, source: "Forbes Aug 2025" },
  "Las Vegas Raiders":      { value: 7.80, source: "Forbes Aug 2025" },
  "Los Angeles Chargers":   { value: 6.05, source: "Forbes Aug 2025" },
  "Dallas Cowboys":         { value: 12.80, source: "Forbes Aug 2025" },
  "New York Giants":        { value: 8.00, source: "Forbes Aug 2025" },
  "Philadelphia Eagles":    { value: 7.65, source: "Forbes Aug 2025" },
  "Washington Commanders":  { value: 7.60, source: "Forbes Aug 2025" },
  "Chicago Bears":          { value: 7.25, source: "Forbes Aug 2025" },
  "Detroit Lions":          { value: 6.40, source: "Forbes Aug 2025" },
  "Green Bay Packers":      { value: 6.30, source: "Forbes Aug 2025" },
  "Minnesota Vikings":      { value: 5.95, source: "Forbes Aug 2025" },
  "Atlanta Falcons":        { value: 5.50, source: "Forbes Aug 2025" },
  "Carolina Panthers":      { value: 5.20, source: "Forbes Aug 2025" },
  "New Orleans Saints":     { value: 5.55, source: "Forbes Aug 2025" },
  "Tampa Bay Buccaneers":   { value: 5.40, source: "Forbes Aug 2025" },
  "Arizona Cardinals":      { value: 5.30, source: "Forbes Aug 2025" },
  "Los Angeles Rams":       { value: 8.40, source: "Forbes Aug 2025" },
  "San Francisco 49ers":    { value: 8.50, source: "Forbes Aug 2025" },
  "Seattle Seahawks":       { value: 6.45, source: "Forbes Aug 2025" },

  // ────────── NBA ──────────
  "Boston Celtics":            { value: 6.80, source: "Forbes Oct 2025" },
  "Brooklyn Nets":             { value: 4.55, source: "Forbes Oct 2025" },
  "New York Knicks":           { value: 9.30, source: "Forbes Oct 2025" },
  "Philadelphia 76ers":        { value: 4.65, source: "Forbes Oct 2025" },
  "Toronto Raptors":           { value: 4.40, source: "Forbes Oct 2025" },
  "Chicago Bulls":             { value: 5.80, source: "Forbes Oct 2025" },
  "Cleveland Cavaliers":       { value: 4.05, source: "Forbes Oct 2025" },
  "Detroit Pistons":           { value: 3.85, source: "Forbes Oct 2025" },
  "Indiana Pacers":            { value: 4.05, source: "Forbes Oct 2025" },
  "Milwaukee Bucks":           { value: 4.40, source: "Forbes Oct 2025" },
  "Atlanta Hawks":             { value: 4.05, source: "Forbes Oct 2025" },
  "Charlotte Hornets":         { value: 3.65, source: "Forbes Oct 2025" },
  "Miami Heat":                { value: 5.40, source: "Forbes Oct 2025" },
  "Orlando Magic":             { value: 3.95, source: "Forbes Oct 2025" },
  "Washington Wizards":        { value: 3.95, source: "Forbes Oct 2025" },
  "Denver Nuggets":            { value: 4.25, source: "Forbes Oct 2025" },
  "Minnesota Timberwolves":    { value: 4.00, source: "Forbes Oct 2025" },
  "Oklahoma City Thunder":     { value: 4.20, source: "Forbes Oct 2025" },
  "Portland Trail Blazers":    { value: 3.95, source: "Forbes Oct 2025" },
  "Utah Jazz":                 { value: 3.95, source: "Forbes Oct 2025" },
  "Golden State Warriors":     { value: 11.00, source: "Forbes Oct 2025" },
  "Los Angeles Clippers":      { value: 5.50, source: "Forbes Oct 2025" },
  "Los Angeles Lakers":        { value: 10.00, source: "Forbes Oct 2025" },
  "Phoenix Suns":              { value: 4.55, source: "Forbes Oct 2025" },
  "Sacramento Kings":          { value: 4.15, source: "Forbes Oct 2025" },
  "Dallas Mavericks":          { value: 5.10, source: "Forbes Oct 2025" },
  "Houston Rockets":           { value: 4.50, source: "Forbes Oct 2025" },
  "Memphis Grizzlies":         { value: 3.70, source: "Forbes Oct 2025" },
  "New Orleans Pelicans":      { value: 3.65, source: "Forbes Oct 2025" },
  "San Antonio Spurs":         { value: 4.30, source: "Forbes Oct 2025" },

  // ────────── MLB ──────────
  "Baltimore Orioles":         { value: 1.85, source: "Forbes Mar 2025" },
  "Boston Red Sox":            { value: 4.80, source: "Forbes Mar 2025" },
  "New York Yankees":          { value: 8.20, source: "Forbes Mar 2025" },
  "Tampa Bay Rays":            { value: 1.25, source: "Forbes Mar 2025" },
  "Toronto Blue Jays":         { value: 2.45, source: "Forbes Mar 2025" },
  "Chicago White Sox":         { value: 2.05, source: "Forbes Mar 2025" },
  "Cleveland Guardians":       { value: 1.45, source: "Forbes Mar 2025" },
  "Detroit Tigers":            { value: 1.70, source: "Forbes Mar 2025" },
  "Kansas City Royals":        { value: 1.35, source: "Forbes Mar 2025" },
  "Minnesota Twins":           { value: 1.55, source: "Forbes Mar 2025" },
  "Houston Astros":            { value: 2.85, source: "Forbes Mar 2025" },
  "Los Angeles Angels":        { value: 2.65, source: "Forbes Mar 2025" },
  "Oakland Athletics":         { value: 1.30, source: "Forbes Mar 2025" },
  "Seattle Mariners":          { value: 2.35, source: "Forbes Mar 2025" },
  "Texas Rangers":             { value: 2.80, source: "Forbes Mar 2025" },
  "Atlanta Braves":            { value: 3.25, source: "Forbes Mar 2025" },
  "Miami Marlins":             { value: 1.30, source: "Forbes Mar 2025" },
  "New York Mets":             { value: 3.20, source: "Forbes Mar 2025" },
  "Philadelphia Phillies":     { value: 3.15, source: "Forbes Mar 2025" },
  "Washington Nationals":      { value: 2.10, source: "Forbes Mar 2025" },
  "Chicago Cubs":              { value: 4.60, source: "Forbes Mar 2025" },
  "Cincinnati Reds":           { value: 1.35, source: "Forbes Mar 2025" },
  "Milwaukee Brewers":         { value: 1.60, source: "Forbes Mar 2025" },
  "Pittsburgh Pirates":        { value: 1.32, source: "Forbes Mar 2025" },
  "St. Louis Cardinals":       { value: 2.60, source: "Forbes Mar 2025" },
  "Arizona Diamondbacks":      { value: 1.55, source: "Forbes Mar 2025" },
  "Colorado Rockies":          { value: 1.55, source: "Forbes Mar 2025" },
  "Los Angeles Dodgers":       { value: 7.73, source: "Forbes Mar 2025" },
  "San Diego Padres":          { value: 2.05, source: "Forbes Mar 2025" },
  "San Francisco Giants":      { value: 4.10, source: "Forbes Mar 2025" },

  // ────────── NHL ──────────
  "Boston Bruins":             { value: 2.60, source: "Forbes Dec 2025" },
  "Buffalo Sabres":            { value: 1.40, source: "Forbes Dec 2025" },
  "Detroit Red Wings":         { value: 1.95, source: "Forbes Dec 2025" },
  "Florida Panthers":          { value: 1.55, source: "Forbes Dec 2025" },
  "Montreal Canadiens":        { value: 3.10, source: "Forbes Dec 2025" },
  "Ottawa Senators":           { value: 1.30, source: "Forbes Dec 2025" },
  "Tampa Bay Lightning":       { value: 1.65, source: "Forbes Dec 2025" },
  "Toronto Maple Leafs":       { value: 4.25, source: "Forbes Dec 2025" },
  "Carolina Hurricanes":       { value: 1.30, source: "Forbes Dec 2025" },
  "Columbus Blue Jackets":     { value: 1.05, source: "Forbes Dec 2025" },
  "New Jersey Devils":         { value: 1.65, source: "Forbes Dec 2025" },
  "New York Islanders":        { value: 1.45, source: "Forbes Dec 2025" },
  "New York Rangers":          { value: 3.65, source: "Forbes Dec 2025" },
  "Philadelphia Flyers":       { value: 2.00, source: "Forbes Dec 2025" },
  "Pittsburgh Penguins":       { value: 1.65, source: "Forbes Dec 2025" },
  "Washington Capitals":       { value: 1.55, source: "Forbes Dec 2025" },
  "Chicago Blackhawks":        { value: 2.35, source: "Forbes Dec 2025" },
  "Colorado Avalanche":        { value: 1.70, source: "Forbes Dec 2025" },
  "Dallas Stars":              { value: 1.40, source: "Forbes Dec 2025" },
  "Minnesota Wild":            { value: 1.55, source: "Forbes Dec 2025" },
  "Nashville Predators":       { value: 1.25, source: "Forbes Dec 2025" },
  "St. Louis Blues":           { value: 1.35, source: "Forbes Dec 2025" },
  "Utah Hockey Club":          { value: 1.40, source: "Forbes Dec 2025" },
  "Winnipeg Jets":             { value: 1.05, source: "Forbes Dec 2025" },
  "Anaheim Ducks":             { value: 1.30, source: "Forbes Dec 2025" },
  "Calgary Flames":             { value: 1.40, source: "Forbes Dec 2025" },
  "Edmonton Oilers":           { value: 2.15, source: "Forbes Dec 2025" },
  "Los Angeles Kings":         { value: 2.00, source: "Forbes Dec 2025" },
  "San Jose Sharks":           { value: 1.15, source: "Forbes Dec 2025" },
  "Seattle Kraken":            { value: 1.85, source: "Forbes Dec 2025" },
  "Vancouver Canucks":         { value: 1.70, source: "Forbes Dec 2025" },
  "Vegas Golden Knights":      { value: 1.85, source: "Forbes Dec 2025" },

  // ────────── MLS ──────────
  "Atlanta United FC":         { value: 1.00, source: "Forbes MLS Nov 2025" },
  "Charlotte FC":              { value: 0.78, source: "Forbes MLS Nov 2025" },
  "Chicago Fire FC":           { value: 0.72, source: "Forbes MLS Nov 2025" },
  "FC Cincinnati":             { value: 0.78, source: "Forbes MLS Nov 2025" },
  "Columbus Crew":             { value: 0.78, source: "Forbes MLS Nov 2025" },
  "D.C. United":               { value: 0.74, source: "Forbes MLS Nov 2025" },
  "Inter Miami CF":            { value: 1.50, source: "Forbes MLS Nov 2025" },
  "CF Montreal":               { value: 0.60, source: "Forbes MLS Nov 2025" },
  "Nashville SC":              { value: 0.78, source: "Forbes MLS Nov 2025" },
  "New England Revolution":    { value: 0.72, source: "Forbes MLS Nov 2025" },
  "New York City FC":          { value: 0.85, source: "Forbes MLS Nov 2025" },
  "New York Red Bulls":        { value: 0.78, source: "Forbes MLS Nov 2025" },
  "Orlando City SC":           { value: 0.75, source: "Forbes MLS Nov 2025" },
  "Philadelphia Union":        { value: 0.70, source: "Forbes MLS Nov 2025" },
  "Toronto FC":                { value: 0.78, source: "Forbes MLS Nov 2025" },
  "Austin FC":                 { value: 0.95, source: "Forbes MLS Nov 2025" },
  "Colorado Rapids":           { value: 0.62, source: "Forbes MLS Nov 2025" },
  "FC Dallas":                 { value: 0.70, source: "Forbes MLS Nov 2025" },
  "Houston Dynamo FC":         { value: 0.70, source: "Forbes MLS Nov 2025" },
  "LA Galaxy":                 { value: 1.05, source: "Forbes MLS Nov 2025" },
  "LAFC":                      { value: 1.55, source: "Forbes MLS Nov 2025" },
  "Minnesota United FC":       { value: 0.70, source: "Forbes MLS Nov 2025" },
  "Portland Timbers":          { value: 0.78, source: "Forbes MLS Nov 2025" },
  "Real Salt Lake":            { value: 0.66, source: "Forbes MLS Nov 2025" },
  "San Diego FC":              { value: 0.85, source: "Sportico Oct 2025 (expansion)" },
  "San Jose Earthquakes":      { value: 0.60, source: "Forbes MLS Nov 2025" },
  "Seattle Sounders FC":       { value: 0.85, source: "Forbes MLS Nov 2025" },
  "Sporting Kansas City":      { value: 0.70, source: "Forbes MLS Nov 2025" },
  "St. Louis City SC":         { value: 0.85, source: "Forbes MLS Nov 2025" },
  "Vancouver Whitecaps FC":    { value: 0.60, source: "Forbes MLS Nov 2025" },

  // ────────── EPL ──────────
  "Arsenal":                   { value: 3.40, source: "Forbes Soccer May 2025" },
  "Aston Villa":               { value: 0.95, source: "Sportico Sep 2025" },
  "Bournemouth":               { value: 0.42, source: "Sportico Sep 2025" },
  "Brentford":                 { value: 0.45, source: "Sportico Sep 2025" },
  "Brighton & Hove Albion":    { value: 0.80, source: "Sportico Sep 2025" },
  "Burnley":                   { value: 0.32, source: "Football Benchmark 2025 (promoted)" },
  "Chelsea":                   { value: 3.55, source: "Forbes Soccer May 2025" },
  "Crystal Palace":            { value: 0.55, source: "Sportico Sep 2025" },
  "Everton":                   { value: 0.65, source: "Sportico Sep 2025" },
  "Fulham":                    { value: 0.60, source: "Sportico Sep 2025" },
  "Liverpool":                 { value: 5.40, source: "Forbes Soccer May 2025" },
  "Luton Town":                { value: null, source: "NOT FOUND (relegated)" },
  "Manchester City":           { value: 6.40, source: "Forbes Soccer May 2025" },
  "Manchester United":         { value: 6.60, source: "Forbes Soccer May 2025" },
  "Newcastle United":          { value: 1.45, source: "Forbes Soccer May 2025" },
  "Nottingham Forest":         { value: 0.55, source: "Sportico Sep 2025" },
  "Sheffield United":          { value: 0.30, source: "Football Benchmark 2025 (Championship)" },
  "Tottenham Hotspur":         { value: 3.40, source: "Forbes Soccer May 2025" },
  "West Ham United":           { value: 1.25, source: "Forbes Soccer May 2025" },
  "Wolverhampton Wanderers":   { value: 0.80, source: "Sportico Sep 2025" },
}
